import { isCriticalDataLoaded } from "../storage/preloadData";

export const isOfflineActionAvailable = async (
  action: "view" | "create" | "edit",
  t?: (key: string) => string
): Promise<{ available: boolean; reason?: string }> => {
  const isOnline = navigator.onLine;

  if (isOnline) {
    return { available: true };
  }

  const hasCriticalData = await isCriticalDataLoaded();

  switch (action) {
    case "view":
      return {
        available: hasCriticalData,
        reason: hasCriticalData
          ? undefined
          : t
          ? t("offline.dataNotLoaded")
          : "Данные не загружены. Требуется подключение к интернету.",
      };

    case "create":
      if (hasCriticalData) {
        return { available: true };
      }
      const user = localStorage.getItem("user");
      if (user) {
        return { available: true };
      }
      return {
        available: false,
        reason: t
          ? t("offline.dataRequiredForCreate")
          : "Для создания требуется подключение к интернету для загрузки данных.",
      };

    case "edit":
      return {
        available: hasCriticalData,
        reason: hasCriticalData
          ? undefined
          : t
          ? t("offline.editUnavailable")
          : "Редактирование недоступно в оффлайн режиме.",
      };

    default:
      return {
        available: false,
        reason: t ? t("offline.actionUnavailable") : "Неизвестное действие",
      };
  }
};

export const getOfflineMessage = (
  action: "view" | "create" | "edit",
  t?: (key: string) => string
): string => {
  if (navigator.onLine) {
    return "";
  }

  if (t) {
    switch (action) {
      case "view":
        return t("offline.viewUnavailable");
      case "create":
        return t("offline.createUnavailable");
      case "edit":
        return t("offline.editUnavailable");
      default:
        return t("offline.actionUnavailable");
    }
  }

  switch (action) {
    case "view":
      return "Просмотр недоступен в оффлайн режиме. Требуется подключение к интернету.";
    case "create":
      return "Создание недоступно в оффлайн режиме. Требуется подключение к интернету.";
    case "edit":
      return "Редактирование недоступно в оффлайн режиме. Требуется подключение к интернету.";
    default:
      return "Действие недоступно в оффлайн режиме.";
  }
};
